import { TOrderForm } from '../contexts/FormProvider'

type TFormSubmitValues = TOrderForm

type TOrderFormForSubmit = TFormSubmitValues & {
  paymentMethod: Defined<TFormSubmitValues['paymentMethod']>
}

type TProps = {
  orderId: ID
  formValues: TOrderFormForSubmit
  paymentCheckScreenRoute: string
}

/**
 * Transforms order form inputs for SubmitOrder mutation.
 */
export const getSubmitVariables = ({ orderId, formValues, paymentCheckScreenRoute }: TProps) => {
  return {
    orderId,
    // contact
    givenName: formValues.givenName,
    familyName: formValues.familyName,
    phone: `${formValues.phonePrefix.trim()}${formValues.phoneNumber.trim()}`,
    email: formValues.email.trim(),
    // order info
    note: formValues.note.trim(),
    paymentMethodId: formValues.paymentMethod.id,
    confirmedAgreementIds: formValues.confirmedAgreements.map((agreement) => agreement.id),
    // return screen URLs
    paymentFinishedScreenUrl: paymentCheckScreenRoute,
    paymentCanceledScreenUrl: paymentCheckScreenRoute,
  }
}
